import React from 'react';

import { FontAwesomeIcon } from '@schoolinks/ui-components';
import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';

import { faSchoolFlag } from '@fortawesome/pro-regular-svg-icons/faSchoolFlag';

import {
  ACCEPTED_STATUS,
  REJECTED_STATUS,
  WAITLISTED_STATUS,
  COMPLETED_STATUS,
  DEFERRED_STATUS,
} from 'modules/CollegeApplicationManager/pages/ApplicationTrackBoard/constants';

export const COMMON_APP_LOGIN_URL = 'https://apply.commonapp.org/login';

/** @todo remove it and use COLLEGE_APPLICATIONS_ONBOARDING insider userBooleans  */
export const COLLEGE_APPLICATIONS_ONBOARDING_BOOLEAN =
  'college_applications_onboarding';

/**
 * Recommender Request Modal
 */
export const DEFAULT_REQUEST_RECOMMENDATION = 'general';
export const GENERAL_REQUEST_RECOMMENDATION = 'general';
export const COLLEGE_SPECIFIC_RECOMMENDATION = 'college-specific';
export const COMMON_APP_RECOMMENDATION_TYPE = 'Teacher Evaluation';
export const RECOMMENDERS_PER_PAGE = 20;

export const SUBJECTS_LIST = [
  'Computer Science',
  'English',
  'Math',
  'Science',
  'Social Studies',
  'World Language',
  'Other',
];

export const DECLINED_STATUS = 'declined';
export const EVENT_DECLINED_STATUS = 'Declined';

export const EXISTING_APPLICATION = 'EXISTING_APPLICATION';

export const ADD_SCHOOL_ERROR_MAP = {
  'You have already created an application for this school.':
    EXISTING_APPLICATION,
};

export const MAX_RECOMMENDATIONS_COUNT_EXCEEDED =
  'max_recommendations_count_exceeded';

export const APPLICATION_METHOD_COMMON_APP = 1;
export const APPLICATION_METHOD_OTHER = 6;

export const RESPONSIBLE_PARTY_STUDENT = 1;
export const RESPONSIBLE_PARTY_K12_ADMIN = 2;
export const RESPONSIBLE_PARTY_MAP = {
  [RESPONSIBLE_PARTY_STUDENT]: 'student',
  [RESPONSIBLE_PARTY_K12_ADMIN]: 'k12_admin',
};

export const FAFSA_SUBMISSION = 'fafsa-submission';
export const TEST_SCORES = 'test-scores';
export const FINANCIAL_AID = 'financial-aid';
export const SRAR = 'self-reported-academic-record-srar';

export const COLLEGE_APPLICATIONS_APP = 'college_applications';
export const ACTIVITY_APP = 'activity';
export const ACTIVITY_ENTITY_MODEL = 'ActivityEntity';
export const APP_MANAGER_V2_APP = 'app_manager_v2';
export const APPLICATION_APP = 'application';
export const APPLICATION_MODEL = 'Application';
export const FINAL_LIST_APP = 'final_list';
export const FINAL_LIST_ITEM_APP = 'final_list_item';
export const FINAL_LIST_MODEL = 'FinalList';
export const FINAL_LIST_ITEM_MODEL = 'FinalListItem';

export const REQUIREMENT_ATTACHMENT_TYPE = 'ATTACHMENT';
export const CLASS_RANK_DISPLAY_NAME = 'Class Rank Report';

export const ENROLLING_STATUS_INDEX = 99;

export const WILL_NOT_COMPLETE_STATUSES = [-1];
export const IN_PROGRESS_STATUSES = [0];
export const COMPLETE_STATUSES = [1, 2, 3, 4, 5, 6];
export const ACCEPTED_STATUSES = [4];
export const WAITLESTED_OR_DEFERRED_STATUSES = [2, 3];
export const PENDING_RESULTS_STATUSES = [1];
export const WITHDRAWN_STATUSES = [5];
export const REJECTED_STATUSES = [6];
export const TERMINAL_STATUSES = [4, 6, 2];
export const ENROLLING_STATUSES = [ENROLLING_STATUS_INDEX];

export const NEW_APP_TYPE = 'new';

export const COMMON_APP_COLLEGE_NAME_FORM_TYPE = [
  'early-decision',
  'early-decision-2',
  'final',
];

export const APP_MANAGER_EMAIL_DIGEST_CATEGORY = 'application_manager_digest';
export const RECOMMENDER_DIGEST = 'recommender_digest';
export const COMMON_APP_METHOD_ID = 1;

export const EMAIL_DIGEST_TOOLTIP = {
  [APP_MANAGER_EMAIL_DIGEST_CATEGORY]:
    'Receive weekly updates on student submissions and document requests by subscribing to the College Application Digest.',
  [RECOMMENDER_DIGEST]:
    'Receive weekly updates on student requests by subscribing to the Recommendation Letter Digest.',
};

export const DAILY_NOTIFICATION_PREFERENCE = 'daily';
export const WEEKLY_NOTIFICATION_PREFERENCE = 'weekly';
export const NEVER_NOTIFICATION_PREFERENCE = 'never';

export const APP_MANAGER_EMAIL_DIGEST_FREQUENCY = [
  {
    label: 'Weekly',
    buttonValue: WEEKLY_NOTIFICATION_PREFERENCE,
  },
  {
    label: 'Daily',
    buttonValue: DAILY_NOTIFICATION_PREFERENCE,
  },
  {
    label: 'Never',
    buttonValue: NEVER_NOTIFICATION_PREFERENCE,
  },
];

export const TAB_NAVIGATION_ITEMS = [
  {
    id: 'overview',
    name: 'Document Manager',
  },
  {
    id: 'track-submission',
    name: 'Track Submission',
  },
  {
    id: 'track-results',
    name: 'Track Results',
  },
  {
    id: 'acceptance-verification',
    name: 'Acceptance Verification',
  },
];

export const DEFAULT_REQUIREMENT_OPTION = {
  name: 'Counselor and Teacher requirements',
  id: null,
};

export const REQUIREMENT_DROPDOWN_OPTIONS = [
  {
    name: 'Counselor and Teacher requirements',
    id: null,
  },
  { name: 'Counselor requirements only', id: 'k12_admin' },
];

export const REQUIREMENT_STATUS_KEY = 'requirementStatus';

export const LANDING_PAGE_INITIAL_FILTERS = {
  notIntegratedInCommonApp: 'False',
  sendStatus: 'incomplete',
};

export const APPLICATION_STAGES = [
  {
    name: 'Submission Requirements',
    description:
      'Send initial transcripts, recommendation letters & other documents.',
    key: 'submission',
  },
  {
    name: 'Mid Year Documents',
    description:
      "Send when senior year students' first semester transcripts become available.",
    key: 'midYear',
  },
  {
    name: 'Enrollment Documents',
    description:
      "Send final transcripts & any other documents to students' chosen colleges.",
    key: 'enrollment',
  },
];

export const TRANSCRIPT_TYPES_BY_STAGE = {
  submission: 'initial_transcript',
  midYear: 'mid_year_transcript',
  enrollment: 'final_transcript',
};

export const UNTRACKED_SUBMISSION_STATUS = 'untracked';
export const UNSUBMITTED_SUBMISSION_STATUS = 'unsubmitted';
export const SUBMITTED_ALL_APPS_SUBMISSION_STATUS = 'submitted_all_apps';

export const ALL_SUBMISSION_STATUS = [
  UNTRACKED_SUBMISSION_STATUS,
  UNSUBMITTED_SUBMISSION_STATUS,
  SUBMITTED_ALL_APPS_SUBMISSION_STATUS,
];

export const TRACK_SUBMISSION_EXPORT_REPORT_OPTIONS = [
  {
    id: 'submission',
    label: 'Application submission',
    type: 'CSV',
  },
  {
    id: 'summary',
    label: 'Student Application Counts',
    type: 'CSV',
  },
];

export const ENROLLMENT_DECIDED = 'enrollment_decided';
export const ENROLLMENT_UNDECIDED = 'enrollment_undecided';

export const ENROLLMENT_STATUS = [ENROLLMENT_DECIDED, ENROLLMENT_UNDECIDED];

export const SENDING_METHOD_KEYS = {
  COMMON_APP: 'COMMON_APP',
  IN_NETWORK: 'IN_NETWORK',
  MAIL: 'MAIL',
  EMAIL: 'EMAIL',
  NOT_SET: 'NOT_SET',
  EMAIL_AND_IN_NETWORK() {
    return [this.EMAIL, this.IN_NETWORK].join(',');
  },
};

export const SENDING_METHODS = [
  {
    value: SENDING_METHOD_KEYS.EMAIL,
    title: 'Email',
  },
  {
    value: SENDING_METHOD_KEYS.IN_NETWORK,
    title: 'In-network',
  },
  {
    value: SENDING_METHOD_KEYS.MAIL,
    title: 'Print and Mail',
  },
  {
    value: SENDING_METHOD_KEYS.COMMON_APP,
    title: 'Common App',
  },
  { value: SENDING_METHOD_KEYS.NOT_SET, title: 'Not set' },
];

export const APPLICATION_TYPES = [
  { value: 'REGULAR_DECISION', title: 'Regular Decision' },
  { value: 'ROLLING', title: 'Rolling' },
  { value: 'PRIORITY', title: 'Priority' },
  { value: 'EARLY_ACTION', title: 'Early Action' },
  { value: 'EARLY_ACTION_2', title: 'Early Action II' },
  { value: 'EARLY_DECISION', title: 'Early Decision' },
  { value: 'EARLY_DECISION_2', title: 'Early Decision II' },
  { value: 'RESTRICTED_EARLY_ACTION', title: 'Restricted Early Action' },
  { value: 'OTHER', title: 'Other' },
];

export const SUBMISSION_STATUSES = [
  {
    value: '0',
    title: 'In Progress',
  },
  {
    value: '0.5',
    title: 'App Submitted',
  },
  {
    value: '1',
    title: 'Completed',
  },
];

export const getRequirementOptions = stage => [
  {
    value: TRANSCRIPT_TYPES_BY_STAGE[stage],
    title: 'Transcript',
  },
  {
    value: 'counselor_recommendation',
    title: 'Counselor Recommendation',
  },
  {
    value: 'ca_counselor_recommendation_form',
    title: 'Counselor Recommendation (CA)',
  },
  {
    value: 'nacac_school_report_form',
    title: 'NACAC School Report',
  },
  {
    value: 'ca_school_form',
    title: 'School Report (CA)',
  },
  {
    value: 'nacac_fee_waiver_form',
    title: 'NACAC Fee Waiver',
  },
  {
    value: 'ca_fee_waiver_form',
    title: 'Fee Waiver (CA)',
  },
  {
    value: 'ca_early_decision_form',
    title: 'Early Decision Agreement (CA)',
  },
  {
    value: 'ca_optional_form',
    title: 'Optional Report (CA)',
  },
  {
    value: 'other',
    title: '“Other” Requirement',
  },
  {
    value: 'teacher_recommendation',
    title: 'Letter of Recommendations/Teacher Evaluations',
  },
];

export const TEACHER_ASSIGNMENT_STATUSES = [
  {
    value: true,
    title: 'Teacher assigned',
  },
  {
    value: false,
    title: 'No teacher assigned',
  },
];

export const SUBMIT_COUNSELOR_PROFILE_TOOLTIP = `Counselor profile must be submitted before completing any NACAC or Common App requirements`;

export const DEFAULT_ACCEPTANCE_VERIFICATION_STATUS = ['pending'];

export const ACCEPTANCE_VERIFICATION_STATUS_FILTERS = [
  {
    label: 'Needs verification',
    value: 'pending',
    color: 'orange',
  },
  {
    label: 'Verified',
    value: 'verified',
    color: 'green',
  },
  {
    label: 'Declined',
    value: 'declined',
    color: 'red',
  },
];

export const STUDENTS_KEY = 'STUDENTS';
export const COLLEGES_KEY = 'COLLEGES';

export const VIEW_BY_COLLEGE = 'colleges';
export const VIEW_BY_STUDENT = 'students';

/**
 * countKeyName here is used to map the count from the BE response
 */
export const APPLICATION_STATUSES = [
  {
    id: 'awaiting',
    label: 'Awaiting results',
    color: 'gray',
    status: COMPLETED_STATUS,
    drawerTitleName: 'pending',
    countKeyName: 'totalAwaitingApplicationsCount',
  },
  {
    id: 'deferred',
    label: 'Deferred',
    color: 'blue-steel',
    status: DEFERRED_STATUS,
    drawerTitleName: 'deferred',
    countKeyName: 'totalDeferredApplicationsCount',
  },
  {
    id: 'denied',
    label: 'Denied',
    color: 'red',
    status: REJECTED_STATUS,
    drawerTitleName: 'denied',
    countKeyName: 'totalRejectedApplicationsCount',
  },
  {
    id: 'waitlisted',
    label: 'Waitlisted',
    color: 'orange',
    status: WAITLISTED_STATUS,
    drawerTitleName: 'waitlisted',
    countKeyName: 'totalWaitlistedApplicationsCount',
  },
  {
    id: 'accepted',
    label: 'Accepted',
    color: 'green',
    status: ACCEPTED_STATUS,
    drawerTitleName: 'accepted',
    countKeyName: 'totalAcceptedApplicationsCount',
  },
];

export const SEGMENT_CONTROL_BUTTONS = [
  {
    label: 'View by student',
    buttonValue: VIEW_BY_STUDENT,
    icon: <FontAwesomeIcon icon={faGraduationCap} />,
  },
  {
    label: 'View by college',
    buttonValue: VIEW_BY_COLLEGE,
    icon: <FontAwesomeIcon icon={faSchoolFlag} />,
  },
];

export const COUNSELOR_PROFILE_FORM_TYPE = 'counselor-profile';
export const SCHOOL_PROFILE_FORM_TYPE = 'school-profile';
export const TEACHER_PROFILE_FORM_TYPE = 'teacher-profile';

export const DOWNLOAD_ACTION = 'download';
export const UPLOAD_ACTION = 'upload';
export const COMPLETE_ACTION = 'complete';
export const VIEW_ACTION = 'view';
export const DELETE_ACTION = 'delete';
export const RESTORE_ACTION = 'restore';
export const DECLINE_ACTION = 'decline';

export const ACTION_TYPE_LABELS = {
  [DOWNLOAD_ACTION]: 'Open',
  [UPLOAD_ACTION]: 'Fulfill',
  [COMPLETE_ACTION]: 'Fulfill',
  [VIEW_ACTION]: 'View',
  [DELETE_ACTION]: 'Remove',
  [RESTORE_ACTION]: 'Restore',
  [DECLINE_ACTION]: 'Decline',
};

export const FULFILLED_ACTIONS = [VIEW_ACTION, DOWNLOAD_ACTION];
export const FULFILL_ACTIONS = [COMPLETE_ACTION, UPLOAD_ACTION];

export const COUNSELOR_RECOMMENDATION_DISPLAY_NAME = 'Counselor Recommendation';

export const COMMON_APP_SENDING_METHOD = 'COMMON_APP';

export const TRANSCRIPT_PDF_SIZE_IN_MB = 2;

export const AWAITING_APPS = 'awaiting';
export const DEFERRED_APPS = 'deferred';
export const DENIED_APPS = 'denied';
export const WAITLISTED_APPS = 'waitlisted';
export const ACCEPTED_APPS = 'accepted';
export const ENROLLING_APPS = 'enrolling';

// Mapping for the values in the bulkUpdateActionsMapping selector
export const TRACK_RESULTS_BY_COLLEGE_EDIT_OPTIONS = [
  { label: 'Awaiting results', value: AWAITING_APPS },
  { label: 'Deferred apps', value: DEFERRED_APPS },
  { label: 'Denied apps', value: DENIED_APPS },
  { label: 'Waitlisted apps', value: WAITLISTED_APPS },
  { label: 'Accepted apps', value: ACCEPTED_APPS },
  { label: 'Enrolling', value: ENROLLING_APPS },
];

export const GUARDIAN_FERPA_STATUS_OPTIONS = [
  { title: 'Not accepted', value: false },
  { title: 'Waived', value: true },
];

export const NON_CA_RELATED_FORM_ERROR = 'non-ca-related-form-error';

export const ApplicationStatus = {
  IN_PROGRESS: 0,
  APPLICATION_SUBMITTED: 0.5,
  COMPLETED: 1,
};

export const RequirementStage = {
  SUBMISSION: 'submission',
  MID_YEAR: 'midYear',
  ENROLLMENT: 'enrollment',
};
